<template lang="pug">
.div(v-if="item && item.metadata")
  q-carousel.full-width.carousel(v-if="thumbnails" v-bind:class="{'custom-dimmed': fullscreen }"
    infinite
    arrows
    animated
    transition-prev="slide-left"
    transition-next="slide-right"
    thumbnails
    swipeable
    :fullscreen.sync="fullscreen"
    v-model="selectedThumb")
    template(v-slot:control)
      q-carousel-control(position="top-right" :offset="[18, 18]")
        q-btn(round dense color="white" text-color="primary"
          :icon="fullscreen ? 'fullscreen_exit' : 'fullscreen'" @click="fullscreen = !fullscreen")
    q-carousel-slide(v-bind:class="{ 'object-photo-fullscreen': fullscreen, 'object-photo': !fullscreen }"
      :name="img" v-for="img in thumbnails" :key="img.iiif" :img-src="`${img.iiif}/full/full/0/default.jpg`")
</template>

<script>
import { Component, Vue, Watch } from 'vue-property-decorator'

export default @Component({
  props: {
    item: Object,
    collectionCode: String
  },
  components: {}
})
class ObjectCarousel extends Vue {
  fullscreen = false
  selectedThumb = null
  thumbnails = []

  @Watch('item')
  itemChanged () {
    // get item thumbnails
    if (!this.item) {
      return
    }
    const ret = (this.item.metadata._files || []).filter(x => x.mime_type.startsWith('image/'))
    this.thumbnails = ret
    if (ret.length) {
      this.selectedThumb = ret[0]
    }
  }

  @Watch('selectedThumb')
  selectedThumbChanged () {
  }

  mounted () {
    this.itemChanged()
  }
}
</script>
<style lang="stylus" scoped>
.object-photo
  background-size cover !important
  -webkit-background-size: cover !important
  -moz-background-size: cover !important
  -o-background-size: cover !important

.object-photo-fullscreen
  background-repeat no-repeat !important
  background-position center center !important
  background-size contain !important
  -webkit-background-size: contain !important
  -moz-background-size: contain !important
  -o-background-size: contain !important

.custom-caption
  text-align center
  padding 12px
  color white
  background-color rgba(0, 0, 0, .5)

.carousel
  background-color rgba(150,150,150,.9)
</style>
